import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/issueManualInvoice', request)
}

export {post}
